import mcconnel_img from "./profile-pics/mcconnel.png";
import pereira_img from './profile-pics/pereira.jpeg'
import itel_img from './profile-pics/itle.jpeg'
import adams_img from './profile-pics/adams.jpeg'
import pires_img from './profile-pics/pires.jpeg'
import francesco_img from './profile-pics/francesco.jpg'
import lopez_img from './profile-pics/lopez.jpg'
import busch_img from './profile-pics/busch.jpeg'
import bushwell_img from './profile-pics/bushwell.png'

const pires = {
  name: "Alda Pires",
  title: "DVM, MPVM, PhD, DACVPM",
  bio: "Alda Pires is currently an Associate Professor for Cooperative Extension AES for Urban Agriculture " +
      "and Food Safety in the Department of Population Health and Reproduction, UC Davis School of Veterinary " +
      "Medicine. Dr. Pires obtained her DVM from UTAD in Portugal. She then completed a residency program in Food " +
      "Animal Reproduction and Herd Health and a Masters of Preventive Veterinary Medicine (MPVM) at UC Davis. " +
      "Dr. Pires received her PhD from Michigan State University with an emphasis in veterinary epidemiology. " +
      "She is a diplomate of the American College of Veterinary Preventive Medicine (ACVPM)." +
      "\n Dr. Pires’ research focuses on applying and developing epidemiological tools to monitor " +
      "potential food safety hazards and identify mitigation strategies to reduce the dissemination " +
      "of foodborne pathogens in pre-harvest and the spread of infectious diseases in alternative agricultural " +
      "systems (including diversified, small-scale, backyard, and organic farms). Dr. Pires works directly with " +
      "Extension Advisor Specialists and educators, producers, stakeholders, and policy makers on various produce " +
      "food safety issues to minimize the introduction and dissemination of foodborne pathogens within the pre-harvest " +
      "farm environment, both at statewide and nationwide levels. The overarching objective of her appointment is to advance" +
      " agricultural sustainability, food safety, and animal health for organic, diversified small-scale production systems and " +
      "urban farming systems. She also serves as Chair of the Recruitment Committee of the MPVM Program at UC Davis, co-chair of " +
      "the Diversified Farming and Food Systems Program Team UC ANR and Scientific Counselor of The Organic Center. ",
  img: pires_img
}

const francesco = {
  name: "Juliette Di Francesco",
  title: "DVM, PhD",
  bio: "Juliette Di Francesco received her DVM from the National Veterinary School of Alfort (France) in 2014. " +
      "She then completed her Master of Public Health degree at the Pasteur-Cnam School of Public Health in Paris," +
      " as part of which she did a research internship at the Pasteur Institute of Cambodia comparing " +
      "the epidemiologic dynamic of Japanese encephalitis between rural and peri-urban settings in Cambodia. " +
      "Juliette's interests in One Health issues led her to Canada, " +
      "where she completed her PhD at the University of Calgary. She investigated how Indigenous knowledge " +
      "and biomarkers of physiological stress could inform muskox conservation in the rapidly changing Arctic. " +
      "Afterwards, she returned to France, where she worked as an epidemiologist at the " +
      "French Armed Forces Center for Epidemiology and Public Health (CESPA), " +
      "before starting a postdoctoral position with Alda Pires at the University of California, Davis. ",
  img: francesco_img
}

const lopez = {
  name: "Beatriz Martínez-López",
  title: "DVM, MPVM, PhD",
  bio: "Beatriz Martínez-López is a Professor of infectious disease epidemiology at the Department of Medicine & Epidemiology, " +
      "Veterinary School, UC Davis and Director of the Center for Animal Disease Modeling and Surveillance" +
      " (CADMS, https://cadms.vetmed.ucdavis.edu) since January 2014, a recognized FAO Reference " +
      "Center for Veterinary Epidemiology. She has more than 100 publications related with the development" +
      " and implementation of quantitative methods such as epidemiological modeling, risk assessment," +
      " geostatistical methods or network analysis to unravel complex epidemiological problems at the " +
      "wild-domestic-human interface. Currently, she is leading the development, implementation and validation " +
      "of novel Big Data analytical and visualization tools and their integration into operational, web-based," +
      " user-friendly platforms such as the Disease BioPortal (http://bioportal.ucdavis.edu/) " +
      "to more timely support animal health decisions in livestock and aquaculture industries.  ",
  img: lopez_img
}

const busch = {
  name: "Rosie Busch",
  title: "DVM",
  bio: "Dr. Rosie Busch is the Sheep and Goat Extension Veterinarian with UC Cooperative Extension and" +
      " the UC Davis School of Veterinary Medicine. She received her DVM from UC Davis, joined a " +
      "rural mixed animal practice in Hollister, CA before returning to UC Davis to complete a residency " +
      "in Large Animal Internal Medicine focusing on livestock. She has years of practical experience working " +
      "in the Livestock Medicine & Surgery service at the Veterinary Medical Teaching Hospital, teaching students" +
      " and residents. Dr. Busch then went to work for the California Department of Food and Agriculture with a team of" +
      " scientists developing evidence-based resources for veterinarians and livestock owners on antimicrobial stewardship." +
      " As extension veterinarian she is currently collaborating on a number of studies looking at practical approaches to improve " +
      "youngstock survival and maternal health and longevity. ",
  img: busch_img
}

const mcconnel = {
  name: "Craig McConnel",
  title: "DVM, PhD",
  bio: "Craig McConnel grew up on a diversified crop and livestock farm in central Idaho.  " +
      "He received his DVM from WSU in 2002. Following an internship in ruminant medicine at the University of Sydney, " +
      "he completed a Master’s degree investigating bovine pinkeye pathogens in Australia. Craig’s research interests " +
      "led him to Colorado State University where he completed a PhD exploring the epidemiology of adult dairy cow mortality." +
      "  In 2010, he joined Charles Sturt University’s School of Animal and Veterinary Science in Wagga Wagga, Australia, " +
      "and then returned to Colorado State University in 2013 as an Assistant Professor in Dairy Population Health Management. " +
      " In 2016, Craig moved to WSU and is an Associate Professor in Veterinary Medicine Extension. ",
  img: mcconnel_img
}

const itle = {
  name: "Amber Itle",
  title: "DVM, PhD",
  bio: "Dr. Amber Itle grew up on her family’s dairy farm in Pennsylvania and then joined the veterinary profession " +
      "shared by her father and sister.  Dr. Itle worked in large animal private practice for 9 years, before joining" +
      " WSDA in 2013.  Dr. Itle is the NW WA regional field veterinarian and the Interim WA State Veterinarian managing" +
      " the Animal Health and the Animal Disease Traceability Programs.  She earned her degree in veterinary medicine " +
      "at the University of Pennsylvania in 2003 and a Master’s Degree in Animal Welfare from the University of " +
      "British Columbia in 2014.",
  img: itel_img
}



const bushwell = {
  name: "Minden L. Buswell",
  title: "DVM, MPH, DACVPM",
  bio: "Since 2014, Minden Buswell has been the " +
      "Washington State Department of Agriculture – Animal Service Division – Reserve Veterinary Corps Coordinator/Epidemiologist II." +
      " She primarily plans, responds, and aids in the recovery for all animal health emergencies." +
      " She graduated from the University of Wisconsin-Madison with an Animal Science degree." +
      " She received her veterinary doctorate at Western University of Health Sciences." +
      " She practiced equine and mixed animal medicine before going back to school " +
      "to complete a Masters in Public Health, and a residency in Veterinary Public Health " +
      "and Preventive Medicine at the University of Minnesota. Upon finishing her residency," +
      " she became board certified within the American College of Veterinary Preventative Medicine. " +
      "She is on the Board of Directors for National Alliance of State Animal and Agricultural Emergency Programs (NASAAEP)" +
      " and currently holds the position of president. She is also a member of the United States Animal Health Association – Committee " +
      "on Animal Emergency Management. In both of these associations, she represents Washington State.",
  img: bushwell_img
}

const pereira = {
  name: "Richard V. Pereira",
  title: "DVM, PhD",
  bio: "Dr Pereira is a clinician in the Livestock Herd Health and Reproduction Service " +
      "in the University of California Veterinary Medical Teaching Hospital. His research " +
      "focus is on the emergence, persistence and transmission ecology of antimicrobial resistant" +
      " and zoonotic bacteria in livestock, with the aim of developing applied interventions to improve " +
      "antimicrobial stewardship through practices that are feasible and that secure animal health and wellbeing.",
  img: pereira_img
}

const adams = {
  name: "Ragan Adams",
  title: "MA, DVM",
  bio: "Ragan Adams joined the CSU Veterinary Extension Specialist team in 2009. " +
      "Community animal disaster planning has been a major interest and she is a" +
      " CSU delegate to the Extension Disaster Educational Network (EDEN), recently serving " +
      "as the vice chair of the Agriculture and Natural Resources Committee. Since the 2020 fires," +
      " she has been the co-lead of the Colorado Agricultural Recovery Task Force. " +
      "The importance of biosecurity to prevent animal and zoonotic infectious disease is" +
      " another area of commitment. She preaches the importance of biosecurity across all" +
      " specialty teams of CSU Extension and is a member of the " +
      "CSU CERES Advisory TEAM (https://www.research.colostate.edu/ceres-agricultural-biosecurity/).",
  img: adams_img
}

export {mcconnel, itle, pereira, adams, bushwell, pires, lopez, francesco, busch}